import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import gql from 'graphql-tag'
import {useQuery} from '@apollo/react-hooks'

import Overview from './Overview'
import Profile from './Profile'
import Bookings from './Bookings'
import Messages from './Messages'
import Availability from './Availability'
import InvoiceLines from './InvoiceLines'
import Invoices from './Invoices'

const getUserQuery = gql`
  query getUser {
    serviceProvider {
      id
      email
    }
  }
`

const Routes = ({setUser}) => {
  const {loading, data} = useQuery(getUserQuery)
  useEffect(() => {
    if (!loading && data && data.serviceProvider) {
      setUser(data.serviceProvider)
    }
  }, [setUser, loading, data])

  return (
    <Switch>
      <Route path="/overview" component={Overview} />
      <Route path="/profile" component={Profile} />
      <Route path="/bookings" component={Bookings} />
      <Route path="/messages" component={Messages} />
      <Route path="/availability" component={Availability} />
      <Route path="/invoicelines" component={InvoiceLines} />
      <Route path="/invoices" component={Invoices} />
      <Redirect to="/overview" />
    </Switch>
  )
}

export default Routes
